import { Component, OnInit, Input } from '@angular/core';
import { AvailableSystemToBeAReplacementViewModel } from '../../action-models';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ActionService } from '../../action.service.service';
import { TranslateService } from '../../../../translate';
import { SetupUndercarriageService } from '../../../setup-undercarriage/setup-undercarriage.service';
import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
@Component({
  selector: 'system-action-view',
  templateUrl: './system-action-view.component.html',
  styleUrls: ['./system-action-view.component.scss'],
   animations: [
    // trigger('fadeInList', [
    //   transition('* => *', [
    //     query(':enter', style({ opacity: 0 }), { optional: true }),
    //     query(':enter', stagger('500ms', [
    //       animate('.5s ease-in', keyframes([
    //         style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
    //         style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
    //       ]))]), { optional: true })
    //   ])
    // ]),
    // trigger('listAnimation', [
    //   transition('* => *', [
    //     query(':enter', style({ opacity: 0 }), { optional: true }),
    //     query(':enter', stagger('500ms', [
    //       animate('.5s ease-in', keyframes([
    //         style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
    //         style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
    //       ]))]), { optional: true })
    //   ])
    // ]),
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )
  ],
})
export class SystemActionViewComponent implements OnInit {
  @Input() system: AvailableSystemToBeAReplacementViewModel;
  @Input() systemType: number;
  userLanguage = 'English';

  FamilyImage_Chain: any = null;
  FamilyImage_Frame: any = null;
  imageUrl: string = "";

  loadingSystem = false;
  constructor(
    private _sanitizer: DomSanitizer,
    private _loadingService: LoadingService,
    private _actionService: ActionService,
    private _translate: TranslateService,
    private _setupService: SetupUndercarriageService
  ) { }

  ngOnInit() {
      this.getFamily();
  }


  getSystemImage(systemType: number): string {
    if (systemType === 1 ) {
      return '/Content/Images/chain.jpg';
    } else if (systemType === 2 ) {
      return '/Content/Images/frame.jpg';
    } else if (this.system.SystemType === 1 ) {
      return '/Content/Images/chain.jpg';
    } else if (this.system.SystemType === 2 ) {
      return '/Content/Images/frame.jpg';
    }
  }

  getFamily() {
      this._setupService.getSystemFamily(this.system.SystemId).subscribe((r: any) => {
          if (r != null) {
              this.FamilyImage_Chain = r.ChainImage;
              this.FamilyImage_Frame = r.FrameImage;

              if (this.system != null) {
                  if (this.system.SystemType === 1) {
                      if (this.FamilyImage_Chain != null) {
                          this.imageUrl = this.FamilyImage_Chain;
                      }
                  } else if (this.system.SystemType === 2) {
                      if (this.FamilyImage_Frame != null) {
                          this.imageUrl = this.FamilyImage_Frame;
                      }
                  }
              }
          }
      });
  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

}
